var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, } from 'react';
import { Redirect } from 'react-router-dom';
import { services } from '../../../shared';
import { SubmissionRouteType } from '../../../shared/models';
import { CustomerTable } from '../../sections/customer/customer-table';
import { ApplicantTable } from '../../sections/applicants/applicant-table';
import { CASES, APPLICATION } from '../../../config/routes';
import { Workflow } from '../../sections/workflow/workflow';
import { Button, FormSelect, PageHeading, CtaBar } from '../../shared';
import { directRouteValues, mortgageDefaultValues, networkDefaultValues } from '../../../shared/types/constants';
import { defaultErrorResponse, hasError } from '../../../shared/types/service-handling';
export var applicationStartInitialState = {
    data: undefined,
    loading: false,
    error: false,
};
export var ApplicantsPage = function (_a) {
    var _b;
    var location = _a.location;
    var _c = useState([]), formTitles = _c[0], setAddClientTitles = _c[1];
    var _d = useState([]), submissionRoutes = _d[0], setSubmissionRoutes = _d[1];
    var _e = useState([]), customerList = _e[0], setCustomerList = _e[1];
    var _f = useState([]), applicantList = _f[0], setApplicantList = _f[1];
    var _g = useState(''), mainApplicantId = _g[0], setMainApplicantId = _g[1];
    var _h = useState(0), maxApplicants = _h[0], setMaxApplicants = _h[1];
    var _j = useState(''), selectedApplicantId = _j[0], setSelectedApplicantId = _j[1];
    var _k = useState(null), selectedSubmissionRoute = _k[0], setSelectedSubmissionRoute = _k[1];
    var _l = useState(''), removedApplicantId = _l[0], setRemovedApplicantId = _l[1];
    var _m = useState(' '), keyPressed = _m[0], setKeyPressed = _m[1];
    var _o = useState('Id'), sortColumn = _o[0], setSortColumn = _o[1];
    var _p = useState('Desc'), sortOrder = _p[0], setSortOrder = _p[1];
    var _q = useState(' '), searchTerm = _q[0], setSearchTerm = _q[1];
    var _r = useState(null), activeCase = _r[0], setActiveCase = _r[1];
    var _s = useState(applicationStartInitialState), applicationStart = _s[0], setApplicationStart = _s[1];
    var _t = useState(0), noOfExistingCustomers = _t[0], setNoOfExistingCustomers = _t[1];
    var _u = useState(true), canProceed = _u[0], setCanProceed = _u[1];
    var _v = useState(false), openCase = _v[0], setOpenCase = _v[1];
    var pageSize = 5;
    var selectExistingCustomer = function (e) {
        var id = e.currentTarget.getAttribute('data-value');
        setSelectedApplicantId(id);
    };
    var changeMainApplicant = function (e) {
        var id = e.currentTarget.getAttribute('data-value');
        setMainApplicantId(id);
    };
    var changeSubmissionRoute = function (e) {
        if (e.currentTarget.selectedOptions.length > 0 &&
            (e.currentTarget.selectedOptions[0].value.startsWith(SubmissionRouteType.MortgageClub.toString()) ||
                e.currentTarget.selectedOptions[0].value.startsWith(SubmissionRouteType.Network.toString()) ||
                e.currentTarget.selectedOptions[0].value.startsWith(SubmissionRouteType.DirectRoute.toString()))) {
            var selectedRoute = (submissionRoutes !== null && submissionRoutes !== void 0 ? submissionRoutes : []).filter(function (route) { return route.value === e.currentTarget.selectedOptions[0].value; });
            if (selectedRoute.length > 0) {
                setSelectedSubmissionRoute(selectedRoute[0]);
            }
        }
        else if (submissionRoutes.length > 1) {
            setSelectedSubmissionRoute(null);
        }
    };
    var removeApplicant = function (e) {
        var id = e.currentTarget.getAttribute('data-value');
        setRemovedApplicantId(id);
    };
    var handleKey = function (e) {
        setKeyPressed(e.currentTarget.value);
    };
    var startApplication = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setApplicationStart(__assign(__assign({}, applicationStart), { loading: true }));
                    setOpenCase(true);
                    return [4 /*yield*/, services.startApplication(mainApplicantId, Number(location.state.loanPurposeId), applicantList, selectedSubmissionRoute)];
                case 1:
                    result = _a.sent();
                    setApplicationStart(result);
                    if (result.data)
                        setActiveCase(result.data);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchCustomers = function (searchTerm) { return __awaiter(void 0, void 0, void 0, function () {
        var customers, totalCustomers;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSearchTerm(searchTerm);
                    return [4 /*yield*/, services.search(searchTerm !== null && searchTerm !== void 0 ? searchTerm : ' ', 1, pageSize)];
                case 1:
                    customers = (_a.sent()).data;
                    (customers !== null && customers !== void 0 ? customers : []).forEach(function (c) {
                        if ((applicantList !== null && applicantList !== void 0 ? applicantList : []).map(function (a) { return a.id; }).indexOf(c.id) === -1) {
                            c.isSelected = false;
                        }
                        else {
                            c.isSelected = true;
                        }
                    });
                    setCustomerList(customers);
                    return [4 /*yield*/, services.getAllCustomers()];
                case 2:
                    totalCustomers = (_a.sent()).data.length;
                    setNoOfExistingCustomers(totalCustomers);
                    return [2 /*return*/];
            }
        });
    }); };
    var getMaxApplicants = function () { return __awaiter(void 0, void 0, void 0, function () {
        var max;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getMaxApplicants()];
                case 1: return [4 /*yield*/, (_a.sent()).data];
                case 2:
                    max = _a.sent();
                    setMaxApplicants(parseInt(max));
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchPageData = function (pageNumber, pageSize) { return __awaiter(void 0, void 0, void 0, function () {
        var customers;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.search(searchTerm !== null && searchTerm !== void 0 ? searchTerm : ' ', pageNumber, pageSize, sortColumn, sortOrder)];
                case 1: return [4 /*yield*/, (_a.sent())
                        .data];
                case 2:
                    customers = _a.sent();
                    (customers !== null && customers !== void 0 ? customers : []).forEach(function (c) {
                        if ((applicantList !== null && applicantList !== void 0 ? applicantList : []).map(function (a) { return a.id; }).indexOf(c.id) === -1) {
                            c.isSelected = false;
                        }
                        else {
                            c.isSelected = true;
                        }
                    });
                    setCustomerList(customers);
                    return [2 /*return*/, (customers !== null && customers !== void 0 ? customers : []).filter(function (c) { return !c.isSelected; })];
            }
        });
    }); };
    var fetchSortedData = function (column, order) { return __awaiter(void 0, void 0, void 0, function () {
        var customers;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSortOrder(order);
                    setSortColumn(column.id);
                    return [4 /*yield*/, services.search(searchTerm !== null && searchTerm !== void 0 ? searchTerm : ' ', 1, pageSize, column.id, order)];
                case 1: return [4 /*yield*/, (_a.sent()).data];
                case 2:
                    customers = _a.sent();
                    (customers !== null && customers !== void 0 ? customers : []).forEach(function (c) {
                        if ((applicantList !== null && applicantList !== void 0 ? applicantList : []).map(function (a) { return a.id; }).indexOf(c.id) === -1) {
                            c.isSelected = false;
                        }
                        else {
                            c.isSelected = true;
                        }
                    });
                    setCustomerList(customers);
                    return [2 /*return*/, (customers !== null && customers !== void 0 ? customers : []).filter(function (c) { return !c.isSelected; })];
            }
        });
    }); };
    var fetchTitlesData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getTitles()];
                case 1:
                    res = (_a.sent()).data;
                    setAddClientTitles(res);
                    return [2 /*return*/];
            }
        });
    }); };
    var getSubmissionRoutes = function () { return __awaiter(void 0, void 0, void 0, function () {
        var mortageClubs, networks, routes;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, services.getMortgageClubs()];
                case 1:
                    mortageClubs = ((_a = (_c.sent()).data) !== null && _a !== void 0 ? _a : []).map(function (club) {
                        var _a, _b, _c;
                        return ({
                            id: (_a = club === null || club === void 0 ? void 0 : club.mortgageClubId) !== null && _a !== void 0 ? _a : 0,
                            displayText: (_b = club === null || club === void 0 ? void 0 : club.name) !== null && _b !== void 0 ? _b : '',
                            value: (_c = SubmissionRouteType.MortgageClub + '_' + (club === null || club === void 0 ? void 0 : club.name)) !== null && _c !== void 0 ? _c : '',
                            type: SubmissionRouteType.MortgageClub,
                            selectable: true,
                        });
                    });
                    return [4 /*yield*/, services.getNetworks()];
                case 2:
                    networks = ((_b = (_c.sent()).data) !== null && _b !== void 0 ? _b : []).map(function (network) {
                        var _a, _b, _c;
                        return ({
                            id: (_a = network === null || network === void 0 ? void 0 : network.networkId) !== null && _a !== void 0 ? _a : 0,
                            displayText: (_b = network === null || network === void 0 ? void 0 : network.name) !== null && _b !== void 0 ? _b : '',
                            value: (_c = SubmissionRouteType.Network + '_' + (network === null || network === void 0 ? void 0 : network.name)) !== null && _c !== void 0 ? _c : '',
                            type: SubmissionRouteType.Network,
                            selectable: true,
                        });
                    });
                    routes = [directRouteValues];
                    if (mortageClubs.length > 0) {
                        routes = __spreadArray(__spreadArray(__spreadArray([], routes, true), [mortgageDefaultValues], false), mortageClubs, true);
                    }
                    if (networks.length > 0) {
                        routes = __spreadArray(__spreadArray(__spreadArray([], routes, true), [networkDefaultValues], false), networks, true);
                    }
                    setSubmissionRoutes(routes);
                    return [2 /*return*/];
            }
        });
    }); };
    var RefreshClientDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var customers;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.search(searchTerm !== null && searchTerm !== void 0 ? searchTerm : ' ', 1, pageSize)];
                case 1: return [4 /*yield*/, (_a.sent()).data];
                case 2:
                    customers = _a.sent();
                    setCustomerList(customers);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getMaxApplicants();
    }, [maxApplicants]);
    useEffect(function () {
        var applicants = (customerList !== null && customerList !== void 0 ? customerList : []).filter(function (a) { return a.id.toString() === selectedApplicantId; });
        if (applicants.length > 0 &&
            (applicantList !== null && applicantList !== void 0 ? applicantList : []).filter(function (a) { return a.id.toString() === selectedApplicantId; }).length === 0 &&
            applicantList.length < maxApplicants) {
            var mappedApplicants = applicants.map(function (a) { return ({
                id: a.id,
                firstName: a.firstName,
                surname: a.surname,
            }); });
            if (mainApplicantId === '') {
                setMainApplicantId(mappedApplicants[0].id.toString());
            }
            setApplicantList(__spreadArray(__spreadArray([], (applicantList !== null && applicantList !== void 0 ? applicantList : []), true), [mappedApplicants[0]], false));
        }
    }, [selectedApplicantId]);
    useEffect(function () {
        fetchCustomers(keyPressed);
    }, [keyPressed]);
    useEffect(function () {
        setRemovedApplicantId('');
        if (removedApplicantId !== null && removedApplicantId !== undefined && removedApplicantId !== '') {
            var applicants = (applicantList !== null && applicantList !== void 0 ? applicantList : []).filter(function (a) { return a.id.toString() === removedApplicantId; });
            if (applicants.length > 0 &&
                (applicantList !== null && applicantList !== void 0 ? applicantList : []).filter(function (a) { return a.id.toString() === removedApplicantId; }).length > 0) {
                var a = applicantList.filter(function (a) { return a.id.toString() !== removedApplicantId; });
                if ((mainApplicantId === '' || mainApplicantId == removedApplicantId) && a.length > 0) {
                    setMainApplicantId(a[0].id.toString());
                }
                else if (a.length === 0) {
                    setMainApplicantId('');
                }
                setSelectedApplicantId('');
                setApplicantList(a);
            }
        }
    }, [removedApplicantId]);
    useEffect(function () {
        var customers = __spreadArray([], customerList, true);
        (customers !== null && customers !== void 0 ? customers : []).forEach(function (c) {
            if ((applicantList !== null && applicantList !== void 0 ? applicantList : []).map(function (a) { return a.id; }).indexOf(c.id) === -1) {
                c.isSelected = false;
            }
            else {
                c.isSelected = true;
            }
        });
        if (mainApplicantId === '' && applicantList.length > 0) {
            setMainApplicantId(applicantList[0].id.toString());
        }
        setCustomerList(customers);
    }, [applicantList]);
    useEffect(function () {
        var customers = __spreadArray([], customerList, true);
        (customers !== null && customers !== void 0 ? customers : []).forEach(function (c) {
            if ((applicantList !== null && applicantList !== void 0 ? applicantList : []).map(function (a) { return a.id; }).indexOf(c.id) === -1) {
                c.isSelected = false;
            }
            else {
                c.isSelected = true;
            }
        });
        if (mainApplicantId === '' && applicantList.length > 0) {
            setMainApplicantId(applicantList[0].id.toString());
        }
        setCustomerList(customers);
    }, [applicantList]);
    useEffect(function () {
        fetchTitlesData();
        fetchCustomers(keyPressed);
        getMaxApplicants();
        getSubmissionRoutes();
    }, []);
    useEffect(function () {
        if (submissionRoutes.length > 1) {
            setCanProceed(mainApplicantId !== '' && selectedSubmissionRoute != null);
        }
    }, [submissionRoutes, mainApplicantId, canProceed, selectedSubmissionRoute]);
    if (!location.state) {
        return React.createElement(Redirect, { to: { pathname: CASES.path } });
    }
    if (activeCase !== null) {
        return (React.createElement(Redirect, { to: {
                pathname: "".concat(APPLICATION.paths[0], "/").concat(activeCase.id),
                state: {
                    loanPurposeId: location.state.loanPurposeId,
                    case: activeCase,
                    applicants: activeCase.applicants,
                },
            } }));
    }
    if (hasError([applicationStart])) {
        return defaultErrorResponse();
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Workflow, { caseId: (_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.applicationApplicantId, loanPurposeId: location.state.loanPurposeId }),
        React.createElement(PageHeading, { headingLevel: 2, title: "Applicants", icon: "applicants", mb: 6 }),
        React.createElement(CustomerTable, { customerList: customerList.filter(function (c) { return !c.isSelected; }), selectFunction: selectExistingCustomer, pageSize: pageSize, sortFunction: fetchSortedData, pageFunction: fetchPageData, selectEnabled: applicantList.length < maxApplicants, handleKey: handleKey, formTitles: formTitles, fetchCustomers: fetchCustomers, noOfExistingCustomers: noOfExistingCustomers, refreshClientDetails: RefreshClientDetails }),
        React.createElement(ApplicantTable, { applicantList: applicantList, selectFunction: removeApplicant, changeMainApplicant: changeMainApplicant, mainApplicantId: mainApplicantId }),
        React.createElement(CtaBar, null,
            React.createElement("div", { className: "c-form-options-position" },
                React.createElement("div", { className: "u-flex" }, submissionRoutes.length > 1 && (React.createElement(FormSelect, { id: "submissionRoutes", options: submissionRoutes, displayDefaultSelect: true, defaultSelectText: 'Select a submission route', changeHandler: changeSubmissionRoute })))),
            React.createElement(Button, { type: "button", variant: "primary", childClasses: "u-flex__align-right", onClick: startApplication, disabled: applicantList.length < 1 || canProceed == false || mainApplicantId == '' || openCase === true, icon: "chevronRight", iconPosition: "right" }, "Continue"))));
};
